import type { SignedInUser } from "./JwtUser";

// Identity of the signed-in user, shared across the app. The values are live bindings, so importers see updates.
export let userId = "";
export let email = "";
export let fullName = "";
/** HowRU database user id, returned by /users/create. Used for user settings. */
export let id = "";

const DATABASE_USER_ID_TIMEOUT_MS = 30000;

let databaseUserIdWaiters: Array<(value: string) => void> = [];

export const setSignedInUser = (user: SignedInUser): void => {
    userId = user.id;
    email = user.email;
    fullName = user.displayName;
};

export const setDatabaseUserId = (value: string): void => {
    id = value;
    const waiters = databaseUserIdWaiters;
    databaseUserIdWaiters = [];
    waiters.forEach((resolve) => resolve(value));
};

/**
 * Resolves the database user id once the signed-in user has been registered.
 * Resolves with an empty string when that does not happen within the timeout.
 */
export const waitForDatabaseUserId = (timeoutMs: number = DATABASE_USER_ID_TIMEOUT_MS): Promise<string> => {
    if (id) {
        return Promise.resolve(id);
    }

    return new Promise((resolve) => {
        const waiter = (value: string) => {
            clearTimeout(timer);
            resolve(value);
        };
        const timer = setTimeout(() => {
            databaseUserIdWaiters = databaseUserIdWaiters.filter((w) => w !== waiter);
            resolve(id);
        }, timeoutMs);
        databaseUserIdWaiters.push(waiter);
    });
};
